import styled from 'styled-components'
import { belowTablet } from 'utilities/styled'
import { Columns } from 'components/flex'
import News from 'lists/news'

export const HeroColumns = styled(Columns)`
    justify-content: space-between;
    margin-bottom: 0;

    ${belowTablet`
        flex-direction: column;
        margin-bottom: 24px;
    `}
`

export const Articles = styled(News)`
    padding: 32px;
`

export const LoadingContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 96px;
    position: relative;
`